export default "__VITE_ASSET__Ceb8lN2T__"